module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "classifieds-new"
    }
  }, [_c('div', {
    staticClass: "new-post-form"
  }, [(!_vm.isFetching) ? [(_vm.fetchErrors.length === 0) ? [_c('h1', [_vm._v("Edit Classifieds Post")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postTitle),
      expression: "postTitle"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Post Title",
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.postTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('markdown-editor', {
    attrs: {
      "placeholder": "Post Content",
      "disabled": _vm.isSaving
    },
    model: {
      value: (_vm.postContent),
      callback: function($$v) {
        _vm.postContent = $$v
      },
      expression: "postContent"
    }
  }), _vm._v(" "), _vm._l((_vm.saveErrors), function(error) {
    return _c('div', {
      staticClass: "validation-messages error"
    }, [_vm._v(_vm._s(error))])
  }), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    on: {
      "click": _vm.cancelPost
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.deletePost
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.submitPost
    }
  }, [_vm._v("Submit")])] : _vm._e(), _vm._v(" "), _vm._l((_vm.fetchErrors), function(error) {
    return _c('div', {
      staticClass: "validation-messages error"
    }, [_vm._v(_vm._s(error))])
  })] : _vm._e(), _vm._v(" "), (_vm.isFetching) ? _c('loader-large') : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2781d7fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/ClassifiedsFeed/ClassifiedsEdit.vue
// module id = 838
// module chunks = 2